import React from "react";
import "../Style/contactUs.css";
const ContactUsBanner = () => {
  return (
    <div className=" flex justify-center items-center text-white z-50 contact-banner">
      <h1 className=" text-white text-[28px] lg:text-[40px] mt-16 font-semibold leading-[97px]">
        Contact Us
      </h1>
    </div>
  );
};

export default ContactUsBanner;
